import React from 'react';
// TODO: Migrate module so that you don’t import from the corp project in a global module
/* eslint-disable restrict-imports/restrict-imports */
import HideableSection from 'corp/components/UI/HideableSection';

export const Section = ({ children, ...props }: $FIXME) => (
  <div>
    <HideableSection {...props}>{children}</HideableSection>
    <style jsx>{`
      div :global(.section) {
        overflow: inherit;
      }
    `}</style>
  </div>
);
